export const API_URL = import.meta.env.VITE_REACT_APP_API_URL as string;
export const SERVICE_URL = import.meta.env.VITE_REACT_APP_SERVICE_URL as string;
export const JWT_SECRET = '123456' as string;
